// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-header .badge[data-v-115ecbdf] {
  float: right;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/equipment-bundles.vue","webpack://./equipment-bundles.vue"],"names":[],"mappings":"AACA;EACI,YAAA;ACAJ","sourcesContent":["\n.card-header .badge {\n    float: right;\n}\n",".card-header .badge {\n  float: right;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
